<template>
	<div class="customer">
		<div class="customer__search">
			<SelectInput
				ref="searchType"
				:select-list="nameTypeList"
				:default-select-value="nameType"
				:big-size="true"
				placeholder="검색어를 입력하세요."
				@change="searchTypeChange"
				@enter="search()"
			/>
		</div>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="search()">검색하기</button>
			<button class="btn-main" @click="searchInit()">
				검색조건 초기화
			</button>
		</div>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<p class="section__info__left">등록: {{ totalItem }}건</p>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						@click="csvDown"
					>
						엑셀다운로드
					</button>
				</div>
			</template>
			<table class="table-main list">
				<thead>
					<tr>
						<th>No.</th>
						<th>법인명</th>
						<th>사업자 등록번호</th>
						<th>대표자명</th>
						<th>브랜드명</th>
						<th>담당자명</th>
						<th>퇴사여부</th>
						<th>이메일1</th>
						<th>이메일2</th>
						<th>등록일</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in customerList" :key="index">
						<td>{{ item.id }}</td>
						<td>
							<RouterLink
								:to="`/intranet/customer-modify/${item.id}`"
								class="link"
							>
								{{ item.companyName || '-' }}
							</RouterLink>
						</td>
						<td>{{ item.registrationNumber || '-' }}</td>
						<td>{{ item.ceoName || '-' }}</td>
						<td>{{ item.brandTitle || '-' }}</td>
						<td>{{ item.managerName || '-' }}</td>
						<td>{{ item.managerIsQuit }}</td>
						<td>{{ item.email || '-' }}</td>
						<td>{{ item.emailExtra || '-' }}</td>
						<td>{{ item.createdAt }}</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<PaginationBox
			class="customer__pagination"
			slot="pagination"
			:totalItem="totalItem"
			:limit="limit"
			:offset="offset"
			@to="clickPagination($event.offset)"
		/>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import SelectInput from '@/components/SelectInput';
	import PaginationBox from '@/components/PaginationBox';
	import moment from 'moment';
	import Util from '@/util';

	export default {
		name: 'CustomerManage',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			SelectInput,
			PaginationBox,
		},
		data() {
			return {
				dateRange: { from: '', to: '' },
				nameTypeList: [
					{ value: 'brandTitle', name: '브랜드명' },
					{ value: 'companyName', name: '법인명' },
					{ value: 'ceoName', name: '대표자명' },
					{ value: 'registrationNumber', name: '사업자 등록번호' },
					{ value: 'managerName', name: '담당자명' },
				],
				nameType: 'brandTitle',
				productTypeList: [
					{ value: 'productName', name: '상품명' },
					{ value: 'productDetail', name: '내역' },
				],
				productType: 'productName',
				publishTex: [
					{ id: null, name: '전체' },
					{ id: 1, name: '발행 완료' },
					{ id: 2, name: '발행 전' },
				],
				isPublish: null,
				depositStatus: [
					{ id: null, name: '전체' },
					{ id: 1, name: '입금 완료' },
					{ id: 2, name: '입금 전' },
				],
				isDeposit: null,
				totalItem: 0,
				limit: 50,
				offset: 0,
				customerList: [],
				searchData: '',
				searchType: '',
				params: {
					limit: this.limit,
					offset: this.offset,
				},
			};
		},
		methods: {
			pushQuery() {
				const query = {
					limit: this.limit,
					offset: this.offset,
				};

				if (this.searchData) {
					query[this.searchType] = this.searchData;
				}

				this.$router.push({ query }).catch(() => {});
			},
			clickPagination(offset) {
				this.offset = offset;
				this.pushQuery();
			},
			setFilter() {
				const query = this.$route.query;
				const queryKeyList = Object.keys(query);
				const nameTypeItem = this.nameTypeList.find(item =>
					queryKeyList.some(key => key === item.value)
				);
				const [nameTypeKey, nameTypeValue] = nameTypeItem
					? [nameTypeItem.value, query[nameTypeItem.value]]
					: ['brandTitle', ''];

				this.searchType = nameTypeKey;
				this.searchData = nameTypeValue;
				this.$refs.searchType.selectModel = nameTypeKey;
				this.$refs.searchType.inputModel = nameTypeValue;

				if (query.offset) {
					this.offset = Number(query.offset);
				}

				if (query.limit) {
					this.limit = Number(query.limit);
				}
			},
			getParams() {
				const params = {
					limit: this.limit,
					offset: this.offset,
				};

				if (this.searchData) {
					if (this.searchType === 'registrationNumber') {
						this.searchData = this.searchData.replace(
							/(\d{3})(\d{2})(\d{5})/,
							'$1-$2-$3'
						);
					}
					params[this.searchType] = this.searchData;
				}

				return params;
			},
			searchInit() {
				this.searchData = '';
				this.$refs.searchType.inputModel = '';
			},
			async getList() {
				try {
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.get(
						'/api/customerManageV2',
						{ params }
					);
					this.totalItem = data.totalCount;
					this.customerList = data.customerManageV2Elements;
					this.customerList.forEach(item => {
						item.managerIsQuit =
							item.managerIsQuit === 0 ? 'N' : 'Y';
						item.createdAt = moment(item.createdAt).format(
							'YYYY-MM-DD HH:mm'
						);
					});
				} catch (err) {
					console.error(err);
					alert('리스트를 불러오는데 실패했습니다.');
				}
			},
			searchTypeChange({ select, input }) {
				this.searchData = input;
				this.searchType = select;
			},
			async csvDown() {
				try {
					const clickCb = async (params, period) => {
						params.limit = params.size;
						const { data, config } = await this.$axiosAdmin2.get(
							'/api/customerManageV2',
							{ params }
						);
						const rows = data.customerManageV2Elements.map(item => [
							item.id,
							item.companyName,
							item.registrationNumber,
							item.ceoName,
							item.brandTitle,
							item.managerName,
							item.managerIsQuit === 0 ? 'N' : 'Y',
							item.email,
							item.emailExtra,
							moment(item.createdAt).format('YYYY-MM-DD HH:mm'),
						]);
						const title = `거래처 관리(${period.replace(/(\s*)/g, '')})_${Date.now()}`;
						Util.getCsv(
							[rows],
							[title],
							[
								[
									'No.',
									'법인명',
									'사업자 등록번호',
									'대표자명',
									'브랜드명',
									'담당자명',
									'퇴사여부',
									'이메일1',
									'이메일2',
									'등록일',
								],
							],
							`글로우픽_${title}`,
							config.url
						);
					};
					this.$store.commit('modal/toggleModal', {
						id: 'ExcelDownList',
						params: {
							total: this.totalItem,
							type: 'csList',
							params: this.getParams(),
							clickCb,
						},
					});
				} catch (err) {
					console.error(err);
				}
			},
			initList() {
				this.setFilter();
				this.getList();
			},
			search() {
				if (
					this.searchType === 'registrationNumber' &&
					this.$refs.searchType.inputModel.length > 0 &&
					this.$refs.searchType.inputModel.length !== 10
				) {
					alert('사업자 등록번호 10자리를 입력해 주세요 (-)제외');
					return;
				}
				this.pushQuery();
			},
		},
		watch: {
			'$route.query'() {
				this.initList();
			},
		},
		mounted() {
			this.initList();
		},
	};
</script>
<style lang="scss" scoped>
	.customer {
		&__search {
			margin-top: 40px;
			padding: 0 20%;
		}

		&__pagination {
			margin-top: 30px;
		}
	}
</style>
